import { render, staticRenderFns } from "./File.vue?vue&type=template&id=149297c3&scoped=true&"
import script from "./file.ts?vue&type=script&lang=ts&"
export * from "./file.ts?vue&type=script&lang=ts&"
import style0 from "./File.vue?vue&type=style&index=0&id=149297c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149297c3",
  null
  
)

export default component.exports